import './Toast.css';
export var flexContainer = '_yjszxq2-3-12-1';
export var icon = '_yjszxq1-3-12-1';
export var root = '_yjszxq0-3-12-1';
export var text = '_yjszxq3-3-12-1';